// extracted by mini-css-extract-plugin
export default {"container":"AcordionSubItem_container__QYpKr","active":"AcordionSubItem_active__GGv+E"};